export default __webpack_public_path__ + "static/media/Wrap of the Masquer of the Sands.3a236611.jpg";